var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg170(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2853)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_2853)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 6H14C11.7909 6 10 7.79086 10 10V28C10 30.2091 11.7909 32 14 32H32C34.2091 32 36 30.2091 36 28V10C36 7.79086 34.2091 6 32 6Z",
    fill: "#A92C2C"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M32 2H14C11.7909 2 10 3.79086 10 6V24C10 26.2091 11.7909 28 14 28H32C34.2091 28 36 26.2091 36 24V6C36 3.79086 34.2091 2 32 2Z",
    fill: "#F13838"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4162 11.99H14.6912V10.82C15.1612 10.82 15.5362 10.78 15.8162 10.7C16.1062 10.62 16.3362 10.49 16.5062 10.31C16.6762 10.12 16.8262 9.85 16.9562 9.5H18.0662V20H16.4162V11.99ZM23.3371 11H20.0071V9.5H24.9571V10.94L22.3771 20H20.6971L23.3371 11ZM28.5029 20.15C27.6929 20.15 27.0729 19.92 26.6429 19.46C26.2129 19 25.9979 18.35 25.9979 17.51V11.99C25.9979 11.15 26.2129 10.5 26.6429 10.04C27.0729 9.58 27.6929 9.35 28.5029 9.35C29.3129 9.35 29.9329 9.58 30.3629 10.04C30.7929 10.5 31.0079 11.15 31.0079 11.99V17.51C31.0079 18.35 30.7929 19 30.3629 19.46C29.9329 19.92 29.3129 20.15 28.5029 20.15ZM28.5029 18.65C29.0729 18.65 29.3579 18.305 29.3579 17.615V11.885C29.3579 11.195 29.0729 10.85 28.5029 10.85C27.9329 10.85 27.6479 11.195 27.6479 11.885V17.615C27.6479 18.305 27.9329 18.65 28.5029 18.65Z",
    fill: "#111820"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_2853",
    x: 0,
    y: 0,
    width: 46,
    height: 46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_2853"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_2853",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2853"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg170);
export default __webpack_public_path__ + "static/media/170.0f6f80252992a8c51bd087a600f48f6d.svg";
export { ForwardRef as ReactComponent };